import { Component } from '@angular/core';
import { Feature } from 'magma/common/interfaces';
import { FeatureFlagService } from 'services/feature-flag.service';

@Component({
  selector: 'account-settings',
  templateUrl: './account-settings.component.pug',
  styleUrls: ['./account-settings.component.scss'],
})
export class AccountSettingsPageComponent {
  constructor(private featureFlagService: FeatureFlagService) { }

  get isAiDreamboothSupported() {
    return this.featureFlagService.isFeatureSupported(Feature.AiDreambooth);
  }
}
